'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


function cbArticleDirective() {
    return {
        scope: true,
        restrict: 'E',
        transclude: {
            'articleTitle': '?articleTitle',
            'articleSubtitle': '?articleSubtitle',
            'articleBody': '?articleBody'
        },
        template: "<article>\r\n    <h2 class=\"article__title\" data-ng-transclude=\"articleTitle\">Default title</h2>\r\n    <h3 class=\"article__subtitle\" data-ng-transclude=\"articleSubtitle\">Default subtitle</h3>\r\n    <div class=\"article__body\" data-ng-transclude=\"articleBody\"></div>\r\n</article>\r\n"
    };
}

exports.default = cbArticleDirective;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/article/cb-article.directive.js
// module id = 846
// module chunks = 0